import AtomsBreakline from "../atoms/AtomsBreakline"
import AtomsText from "../atoms/AtomsText"

const OrganismsCreatorInfo = (props) => {
    return (
        <div className="my-4 text-center">
            <AtomsBreakline length={2}/>
            <AtomsText type="section-title" text="About Creator"/>
            <AtomsText type="subtitle-second" text={<>
                My Name is <b>Leo</b>, a Bachelor's degree graduate in Software Engineering from Telkom University
                (2023). Focused on Web Development and Mobile Development. Enjoys exploring new knowledge and seeking challenges.
            </>}/>
            <AtomsBreakline length={3}/>
            <AtomsText type="section-title" text="About FlazeApps"/>
            <AtomsText type="subtitle-second" text={<>
                <b>FlazeApps</b> is a collection of various applications designed to be useful for daily tasks or to simplify certain processes. 
                Many of these apps are developed by me personally or as part of a team project. You can also view the source code, software documentation, and testing documentation publicly.
            </>}/>
            <AtomsBreakline length={2}/>
        </div>
    )
}

export default OrganismsCreatorInfo